import React, { ReactNode, useState } from "react";
import styles from '../LinkPersonalizado4/linkPersonalizado4.module.scss';
import { useNavigate } from "react-router-dom";

interface LinkPersonalizado4Props {
    href: string;
    isLink?: boolean;
    title: string;
    colorText: string;
    borderColor: string,
    maxWSpan?: boolean;
}

const LinkPersonalizado4: React.FC<LinkPersonalizado4Props> = ({
    href,
    title,
    colorText,
    borderColor,
    maxWSpan = false,
    isLink = false,
}) => {
    const navigate = useNavigate();

    return (
        isLink ?
            <div
                style={{
                    transition: "background 0.5s ease",
                    display: "block",
                    padding: "10px 20px",
                    margin: "10px 0",
                    textDecoration: "none",
                    color: "black",
                    borderRadius: "24px",
                    border: `3px solid ${borderColor}`
                }}
                onClick={() => navigate(href)}
            >
                <div className={`d-flex align-items-center justify-content-center`}>
                    <div className={maxWSpan ? styles["max-w-span"] : styles["min-w-span"]}>
                        <span style={{ color: colorText, fontWeight: "semibold" }}>{title}</span>
                    </div>
                </div>
            </div>
            :
            <a
                href={href}
                target="_blank"
                rel="noreferrer"
                style={{
                    transition: "background 0.5s ease",
                    display: "block",
                    padding: "10px 20px",
                    margin: "10px 0",
                    textDecoration: "none",
                    color: "black",
                    borderRadius: "24px",
                    border: `3px solid ${borderColor}`
                }}
            >

                <div className={`d-flex align-items-center justify-content-center`}>
                    <div className={maxWSpan ? styles["max-w-span"] : styles["min-w-span"]}>
                        <span style={{ color: colorText, fontWeight: "semibold" }}>{title}</span>
                    </div>
                </div>

            </a>
    );
};

export default LinkPersonalizado4;
